import { base, darkenColor } from './base';

export const cloudLight = base
  .extend('cloudLight')

  /**
   * Billing
   */
  .property('invoice.status.paid.background.color', 'rgb(220, 252, 231)')
  .property('invoice.status.due.background.color', 'rgb(254, 249, 195)')
  .property('invoice.status.overdue.background.color', 'rgb(255, 237, 213)')
  .property('invoice.status.failed.background.color', 'rgb(254, 226, 226)')
  .property('invoice.status.void.background.color', 'rgb(243, 244, 246)')

  .property('invoice.status.paid.text.color', 'rgb(22, 101, 52)')
  .property('invoice.status.due.text.color', 'rgb(113, 63, 18)')
  .property('invoice.status.overdue.text.color', 'rgb(124, 45, 18)')
  .property('invoice.status.failed.text.color', 'rgb(127, 29, 29)')
  .property('invoice.status.void.text.color', 'rgb(17, 24, 39)')

  .property(
    'invoice.status.paid.border.color',
    darkenColor('invoice.status.paid.background.color', 5),
  )
  .property(
    'invoice.status.due.border.color',
    darkenColor('invoice.status.due.background.color', 5),
  )
  .property(
    'invoice.status.overdue.border.color',
    darkenColor('invoice.status.overdue.background.color', 5),
  )
  .property(
    'invoice.status.failed.border.color',
    darkenColor('invoice.status.failed.background.color', 5),
  )
  .property(
    'invoice.status.void.border.color',
    darkenColor('invoice.status.void.background.color', 5),
  )

  .property('invoice.status.paid.ping.color', 'rgb(34, 197, 94)')
  .property('invoice.status.due.ping.color', 'rgb(234, 179, 8)')
  .property('invoice.status.overdue.ping.color', 'rgb(249, 115, 22)')
  .property('invoice.status.failed.ping.color', 'rgb(239, 68, 68)')
  .property('invoice.status.void.ping.color', 'rgb(107, 114, 128)')

  /**
   * Campaign
   */
  .property('campaign.status.sending.background.color', 'rgba(191, 219, 254, 0.4)')
  .property('campaign.status.sending.text.color', 'rgba(30, 64, 175, 0.9)')
  .property(
    'campaign.status.sending.border.color',
    darkenColor('campaign.status.sending.background.color', 5),
  )

  .property('campaign.status.scheduled.background.color', 'rgb(237, 233, 254)')
  .property('campaign.status.scheduled.text.color', 'rgb(91, 33, 182)')
  .property(
    'campaign.status.scheduled.border.color',
    darkenColor('campaign.status.scheduled.background.color', 5),
  );
